import { Box } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { API } from 'aws-amplify';
import { AnimateIn } from '../../components/animate-in';
import { uicolors } from '../../theme';
import { FeaturedPromoData } from '../../types';

export function FeaturedPromo() {
  // Query - Featured Promo
  const path = '/featured-promo';
  const { data } = useQuery({
    queryKey: [path],
    queryFn: async () => {
      const response: {
        data: FeaturedPromoData[];
      } = await API.post('DashboardAPI', path, {});

      if (response.data.length) {
        return response.data[0];
      }
      return null;
    },
  });

  if (data && data.Published) {
    return (
      <AnimateIn to="bottom" pixels={250}>
        <Box sx={{ textAlign: 'center' }}>
          <Box
            sx={{
              position: 'relative',
              display: 'inline-block',
            }}
          >
            <Box
              component="img"
              src={data.ImageURL}
              sx={{
                display: 'block',
                width: '100%',
                maxWidth: 1080,
                borderRadius: 5,
                border: `3px solid ${uicolors.gold[500]}`,
              }}
            />
          </Box>
        </Box>
      </AnimateIn>
    );
  } else {
    return null;
  }
}
